import { EventEmitter, Injectable, Input, Output } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import type { EditAmountDialogCloseResult } from 'src/entities/file';
import { DialogEditObservacionesComponent } from 'src/features/file-services/edit-observations/ui/dialog-edit-observaciones/dialog-edit-observaciones.component';
import {
  DialogEditTarifaComponent,
  type DialogEditTarifaData
} from 'src/features/file-services/edit-rate/ui/dialog-edit-tarifa/dialog-edit-tarifa.component';
import { buildEditServiceAmountDialogConfig } from 'src/features/file-services/edit-rate/ui/dialog-edit-tarifa/edit-service-amount-dialog.config';
import { DialogProviderComponent } from 'src/features/file-services/manage-provider/ui/dialog-provider/dialog-provider.component';
import { DialogNumReservaComponent } from 'src/features/file-services/manage-reservation/ui/dialog-num-reserva/dialog-num-reserva.component';
import { DialogReservasManualComponent } from 'src/features/file-services/manage-reservation/ui/dialog-reservas-manual/dialog-reservas-manual.component';
import { DialogServiceComponent } from 'src/features/file-services/manage-service/ui/dialog-service/dialog-service.component';
import { DialogServiceObservacionesComponent } from 'src/features/file-services/manage-service/ui/dialog-service-observaciones/dialog-service-observaciones.component';
import { DialogHistorialComponent } from 'src/features/file-services/view-history/ui/dialog-historial/dialog-historial.component';
import { buildCreateOrderDialogConfig } from 'src/features/service-order/create-order/ui/create-order/create-order-dialog.config';
import {
  CreateOrderComponent,
  CreateOrderDialogData
} from 'src/features/service-order/create-order/ui/create-order/create-order.component';
import { buildDeleteOrderDialogConfig } from 'src/features/service-order/delete-service-order/ui/dialog-delete-os/delete-order-dialog.config';
import {
  DeleteServiceOrderDialogData,
  DialogDeleteOSComponent
} from 'src/features/service-order/delete-service-order/ui/dialog-delete-os/dialog-delete-os.component';
import { DialogEditFechaPagoProgramadaComponent } from 'src/features/service-order/edit-scheduled-payment-date/ui/dialog-edit-fecha-pago-programada/dialog-edit-fecha-pago-programada.component';
import { buildEditFechaPagoDialogConfig } from 'src/features/service-order/edit-scheduled-payment-date/ui/dialog-edit-fecha-pago-programada/edit-fecha-pago-dialog.config';

@Injectable({
  providedIn: 'root'
})
export class FunctionsService {
  @Input() example: any;
  result: any;
  constructor(public dialog: MatDialog) {}
  @Output() disparadorCambiosService = new EventEmitter<string>();
  @Output() disparadorCambiosProvider = new EventEmitter<string>();
  @Output() disparadorCambios = new EventEmitter<string>();
  @Output() disparadorCambiosActivity = new EventEmitter<string>();

  openDialogProvider(
    tipo: String,
    nombreServicio: String,
    idItinerary: String,
    idRegistro: string,
    nombreProveedor: string,
    secction: String,
    categoriaServicio: String,
    locacion?: String
  ): void {
    let dialogRef = this.dialog.open(DialogProviderComponent, {
      width: '600px',
      height: '450px',
      data: {
        tipo,
        nombreServicio,
        idItinerary,
        idRegistro,
        nombreProveedor,
        secction,
        categoriaServicio,
        locacion
      }
    });

    dialogRef.afterClosed().subscribe((result) => {});
  }

  openDialogReservaManual(
    tipo: string,
    nombreServicio: string,
    idItinerary: string,
    idRegistro: string,
    nombreProveedor: string,
    secction: string,
    editcode: boolean = false,
    orderId?: string | null,
    service?: any
  ): MatDialogRef<DialogReservasManualComponent> {
    return this.dialog.open(DialogReservasManualComponent, {
      width: '500px',
      height: editcode ? '300px' : '400px',
      data: {
        tipo,
        nombreServicio,
        idItinerary,
        idRegistro,
        nombreProveedor,
        secction,
        editcode,
        orderId,
        service
      }
    });
  }
  openDialogNumReservaManual(
    tipo: String,
    nombreServicio: String,
    idItinerary: String,
    idRegistro: string,
    nombreProveedor: string,
    secction: String,
    editcode: boolean = false,
    orderId?: string | null,
    service?: any
  ): MatDialogRef<DialogNumReservaComponent> {
    return this.dialog.open(DialogNumReservaComponent, {
      data: {
        tipo,
        nombreServicio,
        idItinerary,
        idRegistro,
        nombreProveedor,
        secction,
        editcode,
        orderId,
        service
      }
    });
  }

  openDialogServiceObservaciones(
    id: string,
    observaciones?: string | null
  ): MatDialogRef<DialogServiceObservacionesComponent> {
    return this.dialog.open(DialogServiceObservacionesComponent, {
      width: '480px',
      data: {
        id,
        observaciones
      }
    });
  }

  openDialogEditTarifa(
    data: DialogEditTarifaData
  ): MatDialogRef<DialogEditTarifaComponent, EditAmountDialogCloseResult> {
    return this.dialog.open(
      DialogEditTarifaComponent,
      buildEditServiceAmountDialogConfig(data)
    );
  }

  // EDIT FECHA PAGO PROGRAMADA
  openDialogEditFechaPagoProgramada({
    service
  }: {
    service: any;
  }): MatDialogRef<DialogEditFechaPagoProgramadaComponent> {
    return this.dialog.open(
      DialogEditFechaPagoProgramadaComponent,
      buildEditFechaPagoDialogConfig({ service })
    );
  }

  /**
   * Abre el modal de creación de OS.
   * TICKET: sin ticketIds → fan-out; con ticketIds → solo esos tickets.
   */
  openCreateOrderDialog(
    serviceIdsOrData: string[] | CreateOrderDialogData,
    contextLabel?: string
  ): MatDialogRef<CreateOrderComponent> {
    const data: CreateOrderDialogData = Array.isArray(serviceIdsOrData)
      ? { serviceIds: serviceIdsOrData, contextLabel }
      : {
          ...serviceIdsOrData,
          contextLabel: serviceIdsOrData.contextLabel ?? contextLabel
        };
    return this.dialog.open(
      CreateOrderComponent,
      buildCreateOrderDialogConfig(data)
    );
  }

  openDeleteOrderDialog(
    service: DeleteServiceOrderDialogData['service'],
    dataAll: any[] = [],
    contextLabel?: string
  ): MatDialogRef<DialogDeleteOSComponent> {
    return this.dialog.open(
      DialogDeleteOSComponent,
      buildDeleteOrderDialogConfig({ service, dataAll, contextLabel })
    );
  }

  openDialogService(
    tipo: String,
    nombreServicio: String,
    idItinerary: String,
    idRegistro: string,
    oldService: any,
    secction: String
  ): void {
    let dialogRef = this.dialog.open(DialogServiceComponent, {
      width: '600px',
      height: '450px',
      data: {
        tipo,
        nombreServicio,
        idItinerary,
        idRegistro,
        oldService,
        secction
      }
    });
  }

  openDialogServicio(
    tipo: String,
    nombreServicio: String,
    idItinerary: String,
    idRegistro: string,
    oldService: any
  ): void {
    let dialogRef = this.dialog.open(DialogServiceComponent, {
      width: '600px',
      height: '450px',
      data: {
        tipo,
        nombreServicio,
        idItinerary,
        idRegistro,
        example: this.example,
        oldService
      }
    });
  }

  openDialogHistorial(historial: any): void {
    let dialogRef = this.dialog.open(DialogHistorialComponent, {
      width: '850px',

      height: '400px',
      data: { historial }
    });
  }

  openDialogEditObservaciones(
    id: any,
    observaciones: any
  ): MatDialogRef<DialogEditObservacionesComponent> {
    return this.dialog.open(DialogEditObservacionesComponent, {
      width: '480px',
      data: { id, observaciones }
    });
  }

  public getResult() {
    return this.result;
  }

  public saveResult(a: any) {
    this.result = a;
  }
  public saveResultService(a: any) {
    this.result = a;
  }
}
